import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, eyebrow, children }) => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="legal-page">
      <div className="w-full max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 pt-28 pb-24">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-[#FF5A1F] text-sm uppercase tracking-widest font-bold transition-colors"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <p className="mt-10 text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold">
          {eyebrow}
        </p>
        <h1 className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter mt-4">
          {title}
        </h1>

        <div className="mt-10 prose prose-invert max-w-none text-zinc-300 leading-relaxed space-y-6 [&_h2]:font-display [&_h2]:uppercase [&_h2]:tracking-tight [&_h2]:text-2xl [&_h2]:sm:text-3xl [&_h2]:font-black [&_h2]:text-white [&_h2]:mt-12 [&_h2]:mb-4 [&_h3]:font-display [&_h3]:uppercase [&_h3]:tracking-tight [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-white [&_h3]:mt-8 [&_h3]:mb-3 [&_a]:text-[#FF5A1F] [&_a:hover]:underline [&_strong]:text-white [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:text-zinc-300">
          {children}
        </div>

        <p className="mt-16 text-xs text-zinc-600 uppercase tracking-widest border-t border-zinc-900 pt-6">
          Última actualización: diciembre 2025
        </p>
      </div>
    </div>
  );
};
